export const logToServer = error => {
	try {
		v12.util.error(typeof error === 'object' && error.error ? error.error : error);
	} catch (error) {
		console.error('Error while posting error to server:', error);
	}
};

export const catchClientErrors = () => {
	window.onerror = () => true;
	window.addEventListener('error', logToServer);
};

export const handleDekuError = (error, errorType) => {
	console.warn(`Catched deku ${errorType} ${error}`);

	logToServer(error);
};
